import { useSelector } from 'react-redux';

import { firebaseUserSelector } from '../../../store/miscellaneous/miscellaneousReducerSelectors';
import { useUser } from './useUser';

export const useCurrentUser = () => {
    const firebaseUser = useSelector(firebaseUserSelector);
    return useUser(firebaseUser?.uid);
};
